export default __webpack_public_path__ + "static/media/users-mm-selected.3aec03ed.svg";